import { render } from "./PhotoBoardView.vue?vue&type=template&id=1a508762&scoped=true"
import script from "./PhotoBoardView.vue?vue&type=script&lang=js"
export * from "./PhotoBoardView.vue?vue&type=script&lang=js"

import "./PhotoBoardView.vue?vue&type=style&index=0&id=1a508762&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a508762"]])

export default __exports__